export const TOKEN_INFO_SESSION_STORAGE_KEY = "accessTokenInfo";
export const VARIANT_TUNNEL_STORAGE_KEY = "X-Backend-Variant";
export const CONTRACT_ENGINES_SESSION_STORAGE_KEY = "contractEngines";
export const RECORDING_SETTING_SESSION_STORAGE_KEY = "recordingSetting";
export const APP_ID = "vPilot";
export const DEFAULT_DETECT_VOLUME = 100;
export const CALIBRATION_MIN_LOG_POWER = 40;
export const CALIBRATION_MAX_LOG_POWER = 90;
